module.exports = __webpack_public_path__ + "static/get-youtube-video-code-7df6e83a058e85d86e69219cd5332d7e.png";